module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mill-list"
  }, _vm._l((_vm.mills), function(mill, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "mill-toggle-content",
      class: {
        active: _vm.expanded.indexOf(index) !== -1
      },
      on: {
        "click": function($event) {
          _vm.toggleContent(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-down",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "mill-name",
      on: {
        "click": function($event) {
          _vm.handleClick(mill)
        }
      }
    }, [_c('div', {
      staticClass: "mill-percentage"
    }, [_vm._v("\n        " + _vm._s(mill.percentage) + "%\n        "), _c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), _c('i', {
      staticClass: "mill-selected fa fa-map-marker",
      class: {
        selected: _vm.selectedMills.indexOf(mill) !== -1
      },
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n      " + _vm._s(index + 1) + ".\n      " + _vm._s(mill.name) + "\n    ")]), _vm._v(" "), _c('dl', {
      staticClass: "mill-content",
      class: {
        active: _vm.expanded.indexOf(index) !== -1
      }
    }, [_c('dt', [_vm._v("Plant Type:")]), _vm._v(" "), _c('dd', {
      domProps: {
        "textContent": _vm._s(mill.type)
      }
    }), _vm._v(" "), _c('dt', [_vm._v("Coverage:")]), _vm._v(" "), _c('dd', {
      domProps: {
        "textContent": _vm._s(mill.coverage + ' Miles')
      }
    }), _vm._v(" "), _c('dt', [_vm._v("Counties:")]), _vm._v(" "), _c('dd', {
      domProps: {
        "textContent": _vm._s(mill.counties)
      }
    })])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b03b264"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MillList.vue
// module id = 117
// module chunks = 0